import { render } from "./NavigationBtn.vue?vue&type=template&id=5cc5a702&scoped=true"
import script from "./NavigationBtn.vue?vue&type=script&lang=js"
export * from "./NavigationBtn.vue?vue&type=script&lang=js"

import "./NavigationBtn.vue?vue&type=style&index=0&id=5cc5a702&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc5a702"]])

export default __exports__